module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av396-35fef3b821c6164ac355a7a91f6aa761.jpg";